import { BranchCollectionModel, BranchCollectionItemModel } from 'forms/shared/types';
import { EmptyBranch } from '../branch/instance';

export const EmptyBranchCollection = (
  name = ''
): BranchCollectionModel<BranchCollectionItemModel> => ({
  branch: EmptyBranch(),
  items: [],
  name,
});

export const EmptyBranchCollectionInstance = EmptyBranchCollection();
